"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveAssignmentsButton = exports.removeAssignmentCssStyle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const fa_1 = require("react-icons/fa");
exports.removeAssignmentCssStyle = (0, react_1.css) `
  .remove-assignment {
    visibility: hidden;
  }

  &:hover {
    .remove-assignment {
      visibility: visible;
    }
  }
`;
function RemoveAssignmentsButton({ onClick }) {
    return ((0, jsx_runtime_1.jsx)("sup", { className: "remove-assignment", children: (0, jsx_runtime_1.jsx)("button", { type: "button", style: {
                padding: 0,
                margin: 0,
            }, onClick: onClick, children: (0, jsx_runtime_1.jsx)(fa_1.FaMinusCircle, { color: "red" }) }) }));
}
exports.RemoveAssignmentsButton = RemoveAssignmentsButton;
